import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import ScrollTo from "vue-scrollto";
import VueLazyload from 'vue-lazyload';
import i18n from '@/lang/i18n'


Vue.use(ScrollTo);
Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})
Vue.config.errorHandler = function (err, vm, info) {
    console.log(err)
    console.log(info)
    console.log(vm)
    if(router.currentRoute.name !== "Home"){
        router.push({
            name: "Home"
        })
    }
};
window.onerror = function(message, source, lineno, colno, error) {
    window.gtag("event", "error global window", {
        event_category: "error global window",
        event_label: error,
        value: 1
    });
    if(router.currentRoute.name !== "Home"){
        router.push({
            name: "Home"
        });
    }
}
Vue.config.productionTip = false;

function loadFirst(info) {
    i18n.locale = info.locale
    sessionAsync(info)
    new Vue({
        router,
        store,
        i18n,
        render: h => h(App)
    }).$mount("#app");
}

function loadAnalytics(e, t) {
    try{
        var a, n = "https:" === document.location.protocol ? "https://" : "http://";

    function o() {
            window.dataLayer = window.dataLayer || [], window.gtag = function() {
                window.dataLayer.push(arguments)
            }, window.gtag("js", new Date), window.gtag("config", e), t()
        }
        a = document.createElement("script"), a.src = n + "www.googletagmanager.com/gtag/js?id=" + e, a.type = "text/javascript", a.onloadDone = !1, a.onload = function() {
            a.onloadDone = !0, o()
        }, a.onerror = function() {
            window.gtag = function(e, t) {}, t()
        }, a.onreadystatechange = function() {
            "loaded" !== a.readyState && "complete" !== a.readyState || a.onloadDone || (a.onloadDone = !0, o())
        }, document.getElementsByTagName("head")[0].appendChild(a)
    }catch(err){
        window.gtag("event", "err loadAnalytics ft", {
            event_category: "err loadAnalytics ft",
            event_label: err,
            value: 1
        });
    }
}

function sessionAsync(info){
    try{
        var data = {
            playName : info.name,
            locale : info.localeFb,
            lang: info.locale,
            device : window.FBInstant.getPlatform(),
            photo : info.picture,
            friends : []
        };
        window.FBInstant.setSessionData(data);
    }catch(err){
        window.gtag("event", "error sessionAsync", {
            event_category: "error sessionAsync",
            event_label: err,
            value: 1
        });
    }
    
}

function setInfo(info, entry) {
    try{
        var a = info.locale;
       
        info.pictureObj = info.picture64;
        if (entry !== null) {
            if (entry.ads && entry.ads.language) {
                if (["hi", "ms", "id", "nl", "ru", "ur", "ar", "es", "pt", "en", "ph", "vi", "it", "tr", "th", "fr", "uk"].includes(entry.ads.language)) {
                    info.locale = entry.ads.language;
                }else{
                    if (["US", "UK", "GB"].includes(info.country.toUpperCase()) && info.locale != "es") {
                        info.locale = "en";
                    }else if (["DE"].includes(info.country.toUpperCase())) {
                        info.locale = "de";
                    }else{
                        info.locale = entry.ads.language;
                    }
                }
                window.gtag("event", "setLanguage", {
                    event_category: "setLanguage",
                    event_label: "entry lang: " + entry.ads.language + "--language: " + info.localeFb + "--" + a + " set " + info.locale,
                    value: 1
                });
            }else if (entry.quiz && entry.quiz.language) {
                if (["hi", "ms", "id", "nl", "ru", "ar", "ur", "ph", "uk"].includes(entry.quiz.language)) {
                    info.locale = entry.quiz.language;
                }else{  
                    if (["US", "UK", "GB"].includes(info.country.toUpperCase()) && info.locale != "es") {
                        info.locale = "en";
                    }else if (["DE"].includes(info.country.toUpperCase())) {
                        info.locale = "de";
                    }else{
                        info.locale = entry.quiz.language;
                    }
                }
                window.gtag("event", "setLanguage", {
                    event_category: "setLanguage",
                    event_label: "entry lang: " + entry.quiz.language + "--language: " + info.localeFb + "--" + a + " set " + info.locale,
                    value: 1
                });
            }
            
        }else{
            window.gtag("event", "setLanguage", {
                event_category: "setLanguage",
                event_label: "fb lang: " + info.localeFb + "--language: " + info.locale +" set "+info.locale,
                value: 1
            });
        }
        store.state.userInfo = info;
        loadFirst(info);
    }catch(err){
        window.gtag("event", "error setInfo", {
            event_category: "error setInfo",
            event_label: err,
            value: 1
        });
    }
}

function startLocal() {
    try{
        var playerPic = 'https://i.imgur.com/xRspZmS.jpg';
        var infoUser = {
            id: 1,
            name: "Thanh Thảo",
            picture: playerPic,
            pictureData: null,
            locale: "vi",
            country: "VN",
            localeFb: "vi_VN",
            contextId: "2501525673196628",
            picture64: null

        };
        // if(Sentry){
        //     Sentry.configureScope((function(e) {
        //         e.setUser(infoUser);
        //     }));
        // }
        var history = ["30624", "40659", "30623"]
        store.dispatch('set_history', history)
        infoUser.locale = setLanguage(infoUser);
        var entry = {
            ads: {
                id: 1111111,
                name: "adsad dsa dsad asd ad",
                language: "zh",
                ref: "cccccc"
            },
            shared: {
                timestamp: "123456789",
                player_id: 222
            }
        };
        entry = null;
        infoUser.entry = entry
        setInfo(infoUser, entry);
    }catch(err){
        console.log(err)
    }
}

function setLanguage(r){
    try{
        var c = r;
        var langDefault = "en";
        r.locale = r.locale.replace("in", "id");
        if (r.country.toUpperCase() == "VN") {
            r.locale = "vi";
        }else if (["MX", "CO", "ES", "VE", "AR", "PE", "CL", "EC", "GT", "CU"].includes(r.country.toUpperCase()) || r.localeFb == "es_US") {
            r.locale = "es";
        }else if (r.country.toUpperCase() == "ID") {
            r.locale = "id";
        }else if (r.country.toUpperCase() == "MY") {
            r.locale = "ms";
        }else if (r.country.toUpperCase() == "TR") {
            r.locale = "tr";
        }else if (r.country.toUpperCase() == "PH") {
            r.locale = "ph";
        }else if (r.country.toUpperCase() == "TH") {
            r.locale = "th";
        }else if (r.country.toUpperCase() == "DE") {
            r.locale = "de";
        }else if (r.country.toUpperCase() == "UA") {
            r.locale = "uk";
        }else if (["US", "UK", "GB"].includes(r.country.toUpperCase())) {
            r.locale = "en";
        }else{
            var a = store.state.languages.find(function(lang) {
                return lang.code == r.locale
            });
            if (typeof a == "undefined") {
                r.locale = langDefault;
            }else{
                r.locale = a.code;
            }
        }
        return r.locale
    }catch(err){   
        window.gtag("event", "error setLanguage", {
            event_category: "error setLanguage",
            event_label: err,
            value: 1
        });
    }
}
function subscribeBot(){
   
    window.FBInstant.player.canSubscribeBotAsync()
    .then(function(can_subscribe ){
        if (can_subscribe) {
            window.FBInstant.player.subscribeBotAsync().then(
            ).catch(function (e) {
                console.log(e)
            });
        }
    })
    .catch(function(error){
        console.log(error)
    })
}

function startGame() {
    // window.FBInstant.initializeAsync().then(function() {
        window.FBInstant.startGameAsync()
        .then(function() {
           subscribeBot()
            var e = window.FBInstant.getEntryPointData(),
            t = window.FBInstant.getLocale(),
            a = window.FBInstant.context.getID(),
            n = window.FBInstant.player.getName(),
            i = window.FBInstant.player.getPhoto() ? window.FBInstant.player.getPhoto() : require('./assets/img/default.jpg'),
           
            s = window.FBInstant.player.getID(),
            r = {
                id: s,
                name: n || "name",
                picture: i,
                pictureData: null,
                locale: t.split("_")[0],
                country: t.split("_")[1],
                localeFb: t,
                contextId: a,
                picture64: null
            };
            console.log(r)
            if (e == null) {
                e = e
            }else if (e.hasOwnProperty("data")) {
                e = e.data
            }
            r.entry = e
            window.FBInstant.player.getDataAsync(["language", "history"])
            .then(function(t) {
                if (typeof t["language"] !== "undefined") {
                    store.dispatch("set_newer", false)
                    window.gtag("event", "setLanguage", {
                        event_category: "setLanguage",
                        event_label: "fb lang: " + r.localeFb + "--language: " + r.locale +" set "+t["language"],
                        value: 1
                    });
                    r.locale = t["language"];
                }else{
                    r.locale = setLanguage(r);
                }
                if (typeof t["history"] !== "undefined") {
                    store.dispatch("set_newer", false)
                    store.dispatch('set_history', t["history"])
                }
                setInfo(r, e)
            }).catch(function(a){
                r.locale = setLanguage(r);
                setInfo(r, e)
            });
            window.FBInstant.logEvent("Landed_Home", 1, {
                language: r.locale
            })
        })
        .catch(function(err){
            window.gtag("event", "error startGame", {
                event_category: "error startGame",
                event_label: err,
                value: 1
            });
        })
    // })
}

loadAnalytics(store.state.GoogleAnalytics, function(){
    try{
        startLocal();
    }catch(err){
        window.gtag("event", "error loadAnalytics", {
                event_category: "error loadAnalytics",
                event_label: err,
                value: 1
            });
    }
})